import { Stack, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Rationale from './Rationale';
import Halfway from './Halfway';
import DeclineItemCards from './DeclineItemCards';

const COPY_BY_VARIANT = {
    swap: {
        heading: 'Swap Declined',
        rationaleTitle: 'Why did you decline this swap?'
    },
    replacementDecline: {
        heading: 'Replacement Declined',
        rationaleTitle: 'Why did you decline this replacement?'
    },
    replacementPartialAccept: {
        heading: 'Replacement Partially Accepted',
        rationaleTitle: 'We noticed you accepted some of these recommendations but declined the rest. Why did you decline them?'
    }
};

function ComplianceDeclineFlow({ currentSwap, declineSwap, setIsDeclining, variant = 'swap' }) {
    const { heading, rationaleTitle } = COPY_BY_VARIANT[variant] ?? COPY_BY_VARIANT.swap;
    const [step, setStep] = useState(0);
    const [checked, setChecked] = useState({
        'inferior-clinical': currentSwap?.recommendations[0].rejection_context['inferior-clinical'] ?? false,
        'inferior-quality': currentSwap?.recommendations[0].rejection_context['inferior-quality'] ?? false,
        'challenging': currentSwap?.recommendations[0].rejection_context['challenging'] ?? false,
        'custom-answer': currentSwap?.recommendations[0].rejection_context['custom-answer'] ?? '',
        'trial': currentSwap?.recommendations[0].rejection_context['trial'] ?? false,
        'wet-lab': currentSwap?.recommendations[0].rejection_context['wet-lab'] ?? false,
        'peer-discussion': currentSwap?.recommendations[0].rejection_context['peer-discussion'] ?? false,
        'vendor-discussion': currentSwap?.recommendations[0].rejection_context['vendor-discussion'] ?? false,
    });
    const [customAnswer, setCustomAnswer] = useState(checked['custom-answer']);

    function closeView() {
        setIsDeclining(false);
    }

    useEffect(() => {
        setChecked({
            'inferior-clinical': currentSwap?.recommendations[0].rejection_context['inferior-clinical'] ?? false,
            'inferior-quality': currentSwap?.recommendations[0].rejection_context['inferior-quality'] ?? false,
            'challenging': currentSwap?.recommendations[0].rejection_context['challenging'] ?? false,
            'custom-answer': currentSwap?.recommendations[0].rejection_context['custom-answer'] ?? '',
            'trial': currentSwap?.recommendations[0].rejection_context['trial'] ?? false,
            'wet-lab': currentSwap?.recommendations[0].rejection_context['wet-lab'] ?? false,
            'peer-discussion': currentSwap?.recommendations[0].rejection_context['peer-discussion'] ?? false,
            'vendor-discussion': currentSwap?.recommendations[0].rejection_context['vendor-discussion'] ?? false,
        });
        setCustomAnswer(checked['custom-answer']);
    }, [currentSwap]);

    return (
        <Stack px={2} py={2} spacing={2} sx={{ backgroundColor: 'white', height: '100%' }}>
            <Typography variant='heavy' sx={{ fontSize: '20px' }}>{heading}</Typography>
            <DeclineItemCards 
                item={currentSwap?.recommendations[0].item} 
                recommendedItem={currentSwap?.recommendations[0].recommended_item}
            />
            { step === 0 && 
                <Rationale 
                    checked={checked} 
                    setChecked={setChecked}  
                    customAnswer={customAnswer}
                    setCustomAnswer={setCustomAnswer}
                    setStep={setStep}
                    closeView={closeView}
                    title={rationaleTitle}
                />
            }
            { step === 1 &&
                <Halfway 
                    checked={checked} 
                    setChecked={setChecked}  
                    customAnswer={customAnswer}
                    setCustomAnswer={setCustomAnswer}
                    setStep={setStep}
                    closeView={closeView}
                    declineSwap={declineSwap}
                />
            }
        </Stack>
    );
}


export default ComplianceDeclineFlow;
